import { useState, useEffect } from 'react'
import { Button } from '@/components/ui/Button'
import { Label } from '@/components/ui/Label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/Select'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/Dialog'

interface BrandOption {
  slug: string
  name: string
  primary_color: string | null
}

interface AddChannelDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  channelLabel: string
  brands: BrandOption[]
  defaultBrandSlug: string | null
  onConfirm: (brandSlug: string) => void
}

export function AddChannelDialog({
  open,
  onOpenChange,
  channelLabel,
  brands,
  defaultBrandSlug,
  onConfirm,
}: AddChannelDialogProps) {
  const [brandSlug, setBrandSlug] = useState(defaultBrandSlug ?? brands[0]?.slug ?? '')

  useEffect(() => {
    if (open) setBrandSlug(defaultBrandSlug ?? brands[0]?.slug ?? '')
  }, [open, defaultBrandSlug, brands])

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add {channelLabel}</DialogTitle>
          <DialogDescription>Choose which brand this channel belongs to.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 py-2">
          <Label>Brand</Label>
          <Select value={brandSlug} onValueChange={setBrandSlug}>
            <SelectTrigger className="cursor-pointer">
              <SelectValue placeholder="Select a brand" />
            </SelectTrigger>
            <SelectContent>
              {brands.map((brand) => (
                <SelectItem key={brand.slug} value={brand.slug} className="cursor-pointer">
                  <span className="flex items-center gap-2">
                    <span
                      className="size-2.5 shrink-0 rounded-full border border-border"
                      style={{ backgroundColor: brand.primary_color || '#10b981' }}
                    />
                    {brand.name}
                  </span>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="cursor-pointer">
            Cancel
          </Button>
          <Button onClick={() => brandSlug && onConfirm(brandSlug)} disabled={!brandSlug} className="cursor-pointer">
            Create
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
